/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from 'react';
import { Icon, Collapse } from '@mui/material';
import clsx from 'clsx';
import { Row, Column } from 'global/components/row';
import { get } from 'global/lib/lodash';
import { Text } from '../text';
import { Accordion, Heading, PanelsContainer } from './styles';

export default (props) => {
  const { panels } = props;
  const [state, setState] = useState({
    expanded: get(props, 'defaultPanel', get(panels, '0.id')),
  });

  return (
    <PanelsContainer>
      {!!props.title && <Text type={'title_large'} style={{ marginBottom: 8 }}>{props.title}</Text>}
      <Accordion as={Column}>
        {panels.map((panel, i) => {
          const isOpen = state.expanded === panel.id;
          return (
            <Row key={i} fullWidth className={clsx('accordionRow', i !== panels.length - 1 ? 'notLast' : '')}>
              <Column fullWidth>
                <Row className="titlerow" fullWidth onClick={() => setState((s) => ({ ...s, expanded: s.expanded === panel.id ? '' : panel.id }))}>
                  <Heading>{panel.title}</Heading>
                  <Icon>{isOpen ? 'expand_less' : 'expand_more'}</Icon>
                </Row>
                <Collapse style={{ width: '100%' }} in={isOpen}>
                  {isOpen && panel.component({})}
                </Collapse>
              </Column>
            </Row>
          );
        })}
      </Accordion>
    </PanelsContainer>
  );
};
